import { gql } from '@/__generated__/index.ts';

gql(`
  fragment TimeSeriesFragment on TimeSeries {
    id
    name
    description
    unit
    isOwner
  }
`);

export const StreamHasTimeSeriesQuery = gql(`
  query StreamHasTimeSeries($id: ID!) {
    streamHasTimeSeries(streamId: $id)
  }
`);

export const StreamTimeSeriesQuery = gql(`
  query StreamTimeSeries($streamId: ID!) {
    streamTimeSeries(streamId: $streamId) {
      ...TimeSeriesFragment
    }
  }
`);

export const TimeSeriesBarsQuery = gql(`
  query TimeSeriesBars($input: TimeSeriesBarsInput!) {
    timeSeriesBars(input: $input) {
      time
      open
      high
      low
      close
    }
  }
`);

export const CreateTimeSeriesMutation = gql(`
  mutation CreateTimeSeries(
    $name: String!
    $unit: String
    $description: String
    $streamId: ID
  ) {
    createTimeSeries(
      name: $name
      unit: $unit
      description: $description
      streamId: $streamId
    ) {
      ...TimeSeriesFragment
    }
  }
`);

export const DeleteTimeSeriesMutation = gql(`
  mutation DeleteTimeSeries($seriesId: ID!) {
    deleteTimeSeries(seriesId: $seriesId)
  }
`);
